import { AxiosService } from './axios.service'

/**
 * Defines the API methods for the service charge
 */
export default class ServiceChargeService {
	static baseURL = 'taxa-de-servico'

	/**
	 * Get the current service charge
	 */
	static getServiceCharge() {
		return AxiosService.get(this.baseURL).then(({ data }) => data.data)
	}
}
